var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContainer"},[_vm._v("Default Page")])
}
var staticRenderFns = []

export { render, staticRenderFns }